/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeRegisterPushRequest
 */
export interface DeRegisterPushRequest {
    /**
     * 
     * @type {string}
     * @memberof DeRegisterPushRequest
     */
    deviceid: string;
}

export function DeRegisterPushRequestFromJSON(json: any): DeRegisterPushRequest {
    return DeRegisterPushRequestFromJSONTyped(json, false);
}

export function DeRegisterPushRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeRegisterPushRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deviceid': json['deviceid'],
    };
}

export function DeRegisterPushRequestToJSON(value?: DeRegisterPushRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deviceid': value.deviceid,
    };
}


